(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(96);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinComponentDidLoadModules", function() { return mixinComponentDidLoadModules; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





/**
 * A HOC that will ensure AMD modules are loaded. Use of this HOC requires an AMD loader is available at runtime.
 *
 * The initializer will be called only once when all modules have loaded.
 *
 * The HOC will mount the component immediately unless mountOnLoad is 'true'.
 *
 * @param {Object} imports - key value pair of import name to require path
 * @param {Function=} initlaizer - an optional function which will be called once all imports have been resolved
 * @param {Boolean} mountOnLoad - if true, the wrapped component will only mount once all imports have resolved,
 *                                otherwise the wrapped component will mount immediately
 */
/* harmony default export */ __webpack_exports__["default"] = (function (imports, initializer, mountOnLoad) {
  let resolved;
  let promise;
  const names = [];
  const paths = [];
  Object.keys(imports).forEach(key => {
    paths.push(imports[key]);
    names.push(key);
  });

  function doRequire(instance) {
    if (!resolved) {
      if (!promise) {
        promise = new Promise(resolve => {
          /* eslint-disable no-undef */
          requirejs(paths, (...args) => {
            resolved = {};
            promise = null;
            names.forEach((name, i) => {
              resolved[name] = args[i];
            });
            initializer && initializer(resolved);
            resolve(resolved);
          });
        });
      }

      promise.then(() => {
        instance.forceUpdateOnce();
      });
    }
  }

  return function (WrappedComponent) {
    class RequireAMD extends react__WEBPACK_IMPORTED_MODULE_2__["Component"] {
      constructor(props) {
        super(props);

        _defineProperty(this, "forceUpdateOnce", void 0);

        _defineProperty(this, "_resolved", void 0);

        _defineProperty(this, "wrappedComponent", void 0);

        _defineProperty(this, "_ref", wc => {
          this.wrappedComponent = wc;

          if (wc) {
            Object(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__["hoistNonReactInstanceFunctions"])(this, wc);
            this._isModulesLoaded() && this._doLoad();
          }
        });

        this._doLoad();

        this.forceUpdateOnce = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["once"])(() => this.forceUpdate());
      }

      componentDidUpdate() {
        this._doLoad();
      }

      _doLoad() {
        if (this._isModulesLoaded() && !this._getResolved()) {
          doRequire(this);
        }
      }

      _isModulesLoaded() {
        return this.props.modulesLoaded !== false;
      }

      _getResolved() {
        if (!this._resolved) {
          if (!resolved) {
            const resolvedModules = {};
            const allResolved = Object.keys(imports).every(key => {
              if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
                return false;
              }

              resolvedModules[key] = this.props[key];
              return true;
            });

            if (allResolved) {
              this._resolved = resolvedModules;
            }
          } else {
            this._resolved = resolved;
          }
        }

        return this._resolved;
      }

      render() {
        const modulesLoaded = this._isModulesLoaded() && !!this._getResolved();

        if (!mountOnLoad || modulesLoaded) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(WrappedComponent, _extends({}, this.props, resolved, {
            ref: this._ref,
            modulesLoaded: modulesLoaded
          }));
        }

        return null;
      }

    }

    _defineProperty(RequireAMD, "propTypes", {
      modulesLoaded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
    });

    _defineProperty(RequireAMD, "WrappedComponent", void 0);

    RequireAMD.WrappedComponent = WrappedComponent;
    return RequireAMD;
  };
}); // Use this mixin to supply a new lifecycle function called 'componentDidLoadModules'
// This lifecycle function will be called once all modules have been loaded via requireAMD HOC.

function mixinComponentDidLoadModules(WrappedComponent) {
  const proto = WrappedComponent.prototype;

  if (proto.componentDidLoadModules) {
    const oriComponentDidMount = proto.componentDidMount;
    const oriComponentDidUpdate = proto.componentDidUpdate;

    proto.componentDidMount = function (...args) {
      // by checking !== false, tests can pass as props the mock modules and not have to also include modulesLoaded={true}
      if (this.props.modulesLoaded !== false) {
        this.componentDidLoadModules();
      }

      oriComponentDidMount && oriComponentDidMount.apply(this, args);
    };

    proto.componentDidUpdate = function (...args) {
      const [prevProps] = args;

      if (!prevProps.modulesLoaded && this.props.modulesLoaded) {
        this.componentDidLoadModules();
      }

      oriComponentDidUpdate && oriComponentDidUpdate.apply(this, args);
    };
  }
}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon-toolkit");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".ace_editor.ace_autocomplete{z-index:9999999 !important}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(17);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 17 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-actionStatus{position:absolute;left:-999em}", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/illustrations-js/no-properties_128.js");

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelMessage; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22);
/* harmony import */ var _PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2016, 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class PanelMessage extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  render() {
    const {
      children,
      topOffset,
      contentGutter
    } = this.props;
    const style = topOffset ? {
      top: `${topOffset}px`,
      overflow: 'auto'
    } : {};
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage",
      style: style
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage__inner"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage__contents",
      gutter: contentGutter
    }, children)));
  }

}

_defineProperty(PanelMessage, "propTypes", {
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  topOffset: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  contentGutter: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.array])
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(23);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-panelMessage{position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden;pointer-events:none;white-space:normal}.bi-common-panelMessage__inner{position:absolute;top:50%;left:0;width:100%;transform:translateY(-50%);text-align:center}[dir=rtl] .bi-common-panelMessage__inner{left:auto;right:0}.bi-common-panelMessage__contents{pointer-events:all;display:inline-block}", ""]);

// exports


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var node_polyglot__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
/* harmony import */ var node_polyglot__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(node_polyglot__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26);
/* harmony import */ var amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1__);
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-common
* (C) Copyright IBM Corp. 2019, 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

 // eslint-disable-line

const StringResource = function (resources) {
  const allResources = Object.assign({}, amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1___default.a, resources);
  this._polyglot = new node_polyglot__WEBPACK_IMPORTED_MODULE_0___default.a({
    phrases: allResources
  });
};
/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */


StringResource.prototype.get = function (key, interpolationOptions) {
  let translated = this._polyglot.t(key, interpolationOptions);

  if (this._polyglot.phrases[key] === undefined) {
    translated = `__NOT_TRANSLATED__(${key})`;
  }

  return translated;
};

/* harmony default export */ __webpack_exports__["default"] = (StringResource);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("node-polyglot");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"from":"From","greaterThan":"Greater than","lessThan":"Less than","ok":"OK","reactError":"This view cannot be rendered now. Please try again later.","reactErrorHeader":"Failed to render UI","reactErrorTrace":"Stack trace","reactErrorDetails":"View details","to":"To","tryAgain":"Try again"},"__cs":{"from":"Od","greaterThan":"Větší než","lessThan":"Menší než","ok":"OK","reactError":"Toto zobrazení nyní nelze vykreslit. Opakujte operaci později.","reactErrorHeader":"Vykreslení uživatelského rozhraní se nezdařilo","reactErrorTrace":"Trasování zásobníku","reactErrorDetails":"Zobrazit podrobnosti","to":"Do","tryAgain":"Zkusit znovu"},"__da":{"from":"Fra","greaterThan":"Større end","lessThan":"Mindre end","ok":"OK","reactError":"Denne oversigt kan ikke gengives nu. Prøv igen senere.","reactErrorHeader":"UI kunne ikke gengives","reactErrorTrace":"Staksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Forsøg igen"},"__de":{"from":"Von","greaterThan":"Größer als","lessThan":"Kleiner als","ok":"OK","reactError":"Diese Ansicht kann momentan nicht dargestellt werden. Wiederholen Sie die Aktion zu einem späteren Zeitpunkt.","reactErrorHeader":"Die Darstellung der Benutzerschnittstelle ist fehlgeschlagen","reactErrorTrace":"Stack-Trace","reactErrorDetails":"Details anzeigen","to":"Bis","tryAgain":"Wiederholen"},"__es":{"from":"Desde","greaterThan":"Mayor que","lessThan":"Menor que","ok":"Aceptar","reactError":"Esta vista no se puede mostrar en este momento. Vuelva a intentarlo más tarde.","reactErrorHeader":"No se ha podido representar la IU","reactErrorTrace":"Seguimiento de pila","reactErrorDetails":"Ver detalles","to":"Para","tryAgain":"Vuelva a intentarlo"},"__fi":{"from":"Alkaa","greaterThan":"Suurempi kuin","lessThan":"Pienempi kuin","ok":"OK","reactError":"Tämän näkymän hahmonnus ei onnistu nyt. Yritä myöhemmin uudelleen.","reactErrorHeader":"Käyttöliittymän hahmonnus epäonnistui","reactErrorTrace":"Pinojäljitys","reactErrorDetails":"Näytä tiedot","to":"Päättyy","tryAgain":"Yritä uudelleen"},"__fr":{"from":"De","greaterThan":"Supérieur à","lessThan":"Inférieur à","ok":"OK","reactError":"Cette vue ne peut pas être rendue maintenant. Veuillez réessayer ultérieurement.","reactErrorHeader":"Echec du rendu de l'interface utilisateur","reactErrorTrace":"Trace de pile","reactErrorDetails":"Afficher les détails","to":"A","tryAgain":"Réessayer"},"__hr":{"from":"Od","greaterThan":"Veće od","lessThan":"Manje od","ok":"OK","reactError":"Ovaj pogled se sad ne može prikazati. Molim, pokušajte ponovno kasnije.","reactErrorHeader":"Prikaz korisničkog sučelja nije uspio","reactErrorTrace":"Praćenje stoga","reactErrorDetails":"Pregled detalja","to":"Do","tryAgain":"Pokušaj ponovno"},"__hu":{"from":"Kezdet","greaterThan":"nagyobb mint","lessThan":"Kisebb, mint","ok":"OK","reactError":"Ezt a nézetet most nem lehet megjeleníteni. Próbálkozzon ismét később.","reactErrorHeader":"A felhasználói felület előállítása nem sikerült","reactErrorTrace":"Veremnyomkövetés","reactErrorDetails":"Részletek megjelenítése","to":"Eddig","tryAgain":"Ismételt próbálkozás"},"__it":{"from":"Da","greaterThan":"Maggiore di","lessThan":"Minore di","ok":"OK","reactError":"Impossibile eseguire ora il rendering di questa vista. Riprovare più tardi.","reactErrorHeader":"Impossibile eseguire il rendering della IU","reactErrorTrace":"Traccia dello stack","reactErrorDetails":"Visualizza dettagli","to":"A","tryAgain":"Ritenta"},"__ja":{"from":"範囲の始まり","greaterThan":"より大きい","lessThan":"より小さい","ok":"OK","reactError":"このビューは現時点ではレンダリングできません。 後で、再試行してください。","reactErrorHeader":"UI のレンダリングに失敗しました","reactErrorTrace":"スタック・トレース","reactErrorDetails":"詳細の表示","to":"範囲の終わり","tryAgain":"再試行してください"},"__kk":{"from":"Кімнен","greaterThan":"артығырақ","lessThan":"кемірек","ok":"OK","reactError":"Бұл көріністі енді көрсету мүмкін емес. Әрекетті кейінірек қайталаңыз.","reactErrorHeader":"UI көрсету сәтсіз аяқталды","reactErrorTrace":"Стекті трасирлеу","reactErrorDetails":"Мәліметтерді көріңіз","to":"Кімге","tryAgain":"Әрекетті қайталау"},"__ko":{"from":"시작","greaterThan":"보다 큼","lessThan":"보다 작음","ok":"확인","reactError":"이 보기는 지금 렌더링할 수 없습니다. 나중에 다시 시도하십시오.","reactErrorHeader":"UI 렌더링에 실패","reactErrorTrace":"스택 추적","reactErrorDetails":"세부사항 보기","to":"종료","tryAgain":"다시 시도"},"__nb":{"from":"Fra","greaterThan":"Større enn","lessThan":"Mindre enn","ok":"OK","reactError":"Denne visningen kan ikke gjengis nå. Prøv igjen senere.","reactErrorHeader":"Kunne ikke gjengi UI","reactErrorTrace":"Stakksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Prøv igjen"},"__nl":{"from":"Van","greaterThan":"Groter dan","lessThan":"Kleiner dan","ok":"OK","reactError":"Deze view kan nu niet worden weergegeven. Probeer het later opnieuw.","reactErrorHeader":"Weergeven van gebruikersinterface is mislukt","reactErrorTrace":"Stacktracering","reactErrorDetails":"Details bekijken","to":"Aan","tryAgain":"Opnieuw proberen"},"__no":{"from":"Fra","greaterThan":"Større enn","lessThan":"Mindre enn","ok":"OK","reactError":"Denne visningen kan ikke gjengis nå. Prøv igjen senere.","reactErrorHeader":"Kunne ikke gjengi UI","reactErrorTrace":"Stakksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Prøv igjen"},"__pl":{"from":"Od","greaterThan":"Większe niż","lessThan":"Mniejsze niż","ok":"OK","reactError":"Tego widoku nie można teraz wyświetlać. Spróbuj ponownie później.","reactErrorHeader":"Renderowanie IU nie powiodło się","reactErrorTrace":"Stos wywołań","reactErrorDetails":"Wyświetl szczegóły","to":"Do","tryAgain":"Spróbuj ponownie"},"__pt":{"from":"De","greaterThan":"Maior que","lessThan":"Menor que","ok":"OK","reactError":"Esta visualização não pode ser renderizada agora. Tente novamente mais tarde.","reactErrorHeader":"Falha ao renderizar a UI","reactErrorTrace":"Rastreio de pilha","reactErrorDetails":"Visualizar detalhes","to":"Para","tryAgain":"Tentar novamente"},"__pt-br":{"from":"De","greaterThan":"Maior que","lessThan":"Menor que","ok":"OK","reactError":"Esta visualização não pode ser renderizada agora. Tente novamente mais tarde.","reactErrorHeader":"Falha ao renderizar a UI","reactErrorTrace":"Rastreio de pilha","reactErrorDetails":"Visualizar detalhes","to":"Para","tryAgain":"Tentar novamente"},"__ro":{"from":"De la","greaterThan":"Mai mare ca","lessThan":"Mai mic ca","ok":"OK","reactError":"Această vizualizare nu poate fi randată acum. Încercaţi din nou mai târziu.","reactErrorHeader":"A eşuat randarea UI","reactErrorTrace":"Urmă stivă","reactErrorDetails":"Vizualizare detalii","to":"Până la","tryAgain":"Încercaţi din nou"},"__ru":{"from":"С","greaterThan":"Больше","lessThan":"Меньше","ok":"ОК","reactError":"Воспроизвести данное представление сейчас невозможно. Повторите попытку позже.","reactErrorHeader":"Не удалось воспроизвести пользовательский интерфейс","reactErrorTrace":"Трассировка стека","reactErrorDetails":"Просмотреть подробности","to":"До","tryAgain":"Попробуйте еще раз"},"__sl":{"from":"Od","greaterThan":"Večje od","lessThan":"Manjše od","ok":"V redu","reactError":"Tega pogleda trenutno ni mogoče upodobiti. Poskusite znova pozneje.","reactErrorHeader":"Upodabljanje UI-ja ni uspelo","reactErrorTrace":"Sled sklada","reactErrorDetails":"Ogled podrobnosti","to":"Za","tryAgain":"Poskusite znova"},"__sv":{"from":"Från","greaterThan":"Större än","lessThan":"Mindre än","ok":"OK","reactError":"Det går inte att rendera vyn nu. Försök igen senare.","reactErrorHeader":"Det gick inte att rendera gränssnittet","reactErrorTrace":"Stackspårning","reactErrorDetails":"Visa detaljer","to":"Till","tryAgain":"Försök igen"},"__th":{"from":"จาก","greaterThan":"มากกว่า","lessThan":"น้อยกว่า","ok":"ตกลง","reactError":"มุมมองนี้ไม่สามารถสร้างการแสดงผลได้ในตอนนี้ โปรดลองใหม่อีกครั้งในภายหลัง","reactErrorHeader":"ล้มเหลวในการสร้างการแสดงผล UI","reactErrorTrace":"สแต็กการติดตาม","reactErrorDetails":"ดูรายละเอียด","to":"ถึง","tryAgain":"ลองอีกครั้ง"},"__tr":{"from":"Başlangıç","greaterThan":"Bundan büyük","lessThan":"Bundan küçük","ok":"Tamam","reactError":"Bu görünüm şu anda görsel olarak oluşturulamıyor. Lütfen daha sonra yeniden deneyin.","reactErrorHeader":"Kullanıcı arabirimi görsel olarak oluşturulamadı","reactErrorTrace":"Yığın izi","reactErrorDetails":"Ayrıntıları Görüntüle","to":"HEDEF","tryAgain":"Yeniden deneyin"},"__zh":{"from":"自","greaterThan":"大于","lessThan":"小于","ok":"确定","reactError":"现在无法呈现此视图。请稍后重试。","reactErrorHeader":"未能呈现 UI","reactErrorTrace":"堆栈跟踪","reactErrorDetails":"查看详细信息","to":"到","tryAgain":"重试"},"__zh-cn":{"from":"自","greaterThan":"大于","lessThan":"小于","ok":"确定","reactError":"现在无法呈现此视图。请稍后重试。","reactErrorHeader":"未能呈现 UI","reactErrorTrace":"堆栈跟踪","reactErrorDetails":"查看详细信息","to":"到","tryAgain":"重试"},"__zh-tw":{"from":"從","greaterThan":"大於","lessThan":"小於","ok":"確定","reactError":"此視圖無法立即呈現。請稍後重試。","reactErrorHeader":"無法呈現使用者介面","reactErrorTrace":"堆疊追蹤","reactErrorDetails":"檢視詳細資料","to":"到","tryAgain":"重試"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"collapse":"Collapse","confidenceLevelHigh":"High","confidenceLevelLow":"Low","confidenceLevelMedium":"Medium","confidenceLevelOutOfBoundary":"Out of boundary","errorTxtConfirm":"Passwords do not match.","errorTxtCurrent":"Invalid password","errorTxtPwd":"New password cannot match the current password.","expand":"Expand","labelConfirm":"Confirm password","labelCurrent":"Current password","labelPwd":"Password","successTxtConfirm":"Passwords match.","wordCloudContainer":"Word cloud container","details":"Details"},"__cs":{"collapse":"Sbalit","confidenceLevelHigh":"Vysoké","confidenceLevelLow":"Nízké","confidenceLevelMedium":"Střední","confidenceLevelOutOfBoundary":"Mimo hranice","errorTxtConfirm":"Hesla se neshodují.","errorTxtCurrent":"Neplatné heslo","errorTxtPwd":"Nové heslo nesmí být shodné s heslem aktuálním.","expand":"Rozbalit","labelConfirm":"Potvrdit heslo","labelCurrent":"Aktuální heslo","labelPwd":"Heslo","successTxtConfirm":"Hesla se shodují.","wordCloudContainer":"Kontejner shluku slov","details":"Podrobnosti"},"__da":{"collapse":"Skjul","confidenceLevelHigh":"Høj","confidenceLevelLow":"Lav","confidenceLevelMedium":"Mellem","confidenceLevelOutOfBoundary":"Uden for interval","errorTxtConfirm":"Kodeordene er ikke ens.","errorTxtCurrent":"Ugyldigt kodeord","errorTxtPwd":"Nyt kodeord kan ikke være det samme som det aktuelle.","expand":"Udvid","labelConfirm":"Bekræft kodeord","labelCurrent":"Aktuelt kodeord","labelPwd":"Kodeord","successTxtConfirm":"Kodeordene er ens.","wordCloudContainer":"Word Cloud-opbevaringssted","details":"Detaljer"},"__de":{"collapse":"Ausblenden","confidenceLevelHigh":"Hoch","confidenceLevelLow":"Niedrig","confidenceLevelMedium":"Mittel","confidenceLevelOutOfBoundary":"Außerhalb des Grenzwerts","errorTxtConfirm":"Die Kennwörter stimmen nicht überein.","errorTxtCurrent":"Ungültiges Kennwort","errorTxtPwd":"Das neue Kennwort darf nicht mit dem aktuellen Kennwort übereinstimmen.","expand":"Einblenden","labelConfirm":"Kennwort bestätigen","labelCurrent":"Aktuelles Kennwort","labelPwd":"Kennwort","successTxtConfirm":"Die Kennwörter stimmen überein.","wordCloudContainer":"Wortwolkencontainer","details":"Details"},"__es":{"collapse":"Contraer","confidenceLevelHigh":"Alta","confidenceLevelLow":"Baja","confidenceLevelMedium":"Media","confidenceLevelOutOfBoundary":"Fuera de límite","errorTxtConfirm":"Las contraseñas no coinciden.","errorTxtCurrent":"Contraseña no válida","errorTxtPwd":"La nueva contraseña no puede coincidir con la contraseña actual.","expand":"Expandir","labelConfirm":"Confirmar contraseña","labelCurrent":"Contraseña actual","labelPwd":"Contraseña","successTxtConfirm":"Las contraseñas coinciden.","wordCloudContainer":"Contenedor de nube de palabras","details":"Detalles"},"__fi":{"collapse":"Tiivistä","confidenceLevelHigh":"Suuri","confidenceLevelLow":"Pieni","confidenceLevelMedium":"Keskikokoinen","confidenceLevelOutOfBoundary":"Rajan ulkopuolella","errorTxtConfirm":"Salasanat eivät täsmää.","errorTxtCurrent":"Kelpaamaton salasana","errorTxtPwd":"Uusi salasana ei voi olla sama kuin vanha salasana.","expand":"Laajenna","labelConfirm":"Vahvista salasana","labelCurrent":"Nykyinen salasana","labelPwd":"Salasana","successTxtConfirm":"Salasanat täsmäävät.","wordCloudContainer":"Sanajoukkosäilö","details":"Tiedot"},"__fr":{"collapse":"Réduire","confidenceLevelHigh":"Elevé","confidenceLevelLow":"Faible","confidenceLevelMedium":"Moyen","confidenceLevelOutOfBoundary":"Hors limite","errorTxtConfirm":"Les mots de passe ne concordent pas.","errorTxtCurrent":"Mot de passe non valide","errorTxtPwd":"Le nouveau mot de passe ne doit pas correspondre au mot de passe en cours.","expand":"Développer","labelConfirm":"Confirmation du mot de passe","labelCurrent":"Mot de passe en cours","labelPwd":"Mot de passe","successTxtConfirm":"Les mots de passe concordent.","wordCloudContainer":"Conteneur de nuage de mots","details":"Détails"},"__hr":{"collapse":"Skupi","confidenceLevelHigh":"Visok","confidenceLevelLow":"Nizak","confidenceLevelMedium":"Srednji","confidenceLevelOutOfBoundary":"Izvan granica","errorTxtConfirm":"Lozinke se ne podudaraju.","errorTxtCurrent":"Pogrešna lozinka","errorTxtPwd":"Nova lozinka ne može se podudarati s trenutnom lozinkom.","expand":"Proširi","labelConfirm":"Potvrda lozinke","labelCurrent":"Trenutna lozinka","labelPwd":"Lozinka","successTxtConfirm":"Lozinke se podudaraju.","wordCloudContainer":"Spremnik oblaka s riječima","details":"Detalji"},"__hu":{"collapse":"Visszazárás","confidenceLevelHigh":"Felső","confidenceLevelLow":"Alsó","confidenceLevelMedium":"Közepes","confidenceLevelOutOfBoundary":"Határvonalon kívül esik","errorTxtConfirm":"A jelszavak nem egyeznek.","errorTxtCurrent":"Érvénytelen jelszó","errorTxtPwd":"Az új jelszó nem egyezhet meg az aktuális jelszóval.","expand":"Kibontás","labelConfirm":"Jelszó megerősítése","labelCurrent":"Aktuális jelszó","labelPwd":"Jelszó","successTxtConfirm":"A jelszavak egyeznek.","wordCloudContainer":"Szó felhős tároló","details":"Részletek"},"__it":{"collapse":"Comprimi","confidenceLevelHigh":"Alto","confidenceLevelLow":"Basso","confidenceLevelMedium":"Medio","confidenceLevelOutOfBoundary":"Fuori dall'intervallo","errorTxtConfirm":"Le password non corrispondono.","errorTxtCurrent":"Password non valida","errorTxtPwd":"La nuova password non può corrispondere alla password attuale.","expand":"Espandi","labelConfirm":"Conferma password","labelCurrent":"Password attuale","labelPwd":"Password","successTxtConfirm":"Le password corrispondono.","wordCloudContainer":"Contenitore Word cloud","details":"Dettagli"},"__ja":{"collapse":"省略","confidenceLevelHigh":"最大","confidenceLevelLow":"最小","confidenceLevelMedium":"標準の書式","confidenceLevelOutOfBoundary":"境界を超えています","errorTxtConfirm":"パスワードが一致しません。","errorTxtCurrent":"無効なパスワード","errorTxtPwd":"新しいパスワードが現在のパスワードと一致しません。","expand":"展開","labelConfirm":"パスワードの確認","labelCurrent":"現在のパスワード","labelPwd":"パスワード","successTxtConfirm":"パスワードが一致しました。","wordCloudContainer":"ワード・クラウド・コンテナー","details":"詳細"},"__kk":{"collapse":"Тасалау","confidenceLevelHigh":"Жоғары","confidenceLevelLow":"Төмен","confidenceLevelMedium":"Орташа","confidenceLevelOutOfBoundary":"Шектен тыс","errorTxtConfirm":"Құпия сөздер сәйкес емес.","errorTxtCurrent":"Жарамсыз құпия сөз","errorTxtPwd":"Жаңа құпия сөз қазіргі ағымдағы құпия сөзге сәйкес келмейді.","expand":"Кеңейту","labelConfirm":"Құпия сөзді растау","labelCurrent":"Ағымдағы Құпия сөз","labelPwd":"Құпия сөз","successTxtConfirm":"Сәйкес құпія сөздер.","wordCloudContainer":"Сөз бұлтты контейнері","details":"Мәліметтер"},"__ko":{"collapse":"접기","confidenceLevelHigh":"높음","confidenceLevelLow":"낮음","confidenceLevelMedium":"중간","confidenceLevelOutOfBoundary":"경계를 벗어남","errorTxtConfirm":"비밀번호가 일치하지 않습니다.","errorTxtCurrent":"올바르지 않은 비밀번호","errorTxtPwd":"새 비밀번호는 현재 비밀번호와 일치할 수 없습니다.","expand":"펼치기","labelConfirm":"비밀번호 확인","labelCurrent":"현재 비밀번호","labelPwd":"비밀번호","successTxtConfirm":"비밀번호가 일치합니다.","wordCloudContainer":"단어 클라우드 컨테이너","details":"세부사항"},"__nb":{"collapse":"Komprimer","confidenceLevelHigh":"Høy","confidenceLevelLow":"Lav","confidenceLevelMedium":"Middels","confidenceLevelOutOfBoundary":"Utenfor grensen","errorTxtConfirm":"Passordene samsvarer ikke.","errorTxtCurrent":"Ugyldig passord","errorTxtPwd":"Nytt passord kan ikke være likt gjeldende passord.","expand":"Utvid","labelConfirm":"Bekreft passord","labelCurrent":"Gjeldende passord","labelPwd":"Passord","successTxtConfirm":"Passordene samsvarer.","wordCloudContainer":"Ordskycontainer","details":"Detaljer"},"__nl":{"collapse":"Samenvouwen","confidenceLevelHigh":"Hoogste","confidenceLevelLow":"Laagste","confidenceLevelMedium":"Medium","confidenceLevelOutOfBoundary":"Buiten de begrenzing","errorTxtConfirm":"De wachtwoorden zijn niet gelijk.\n","errorTxtCurrent":"Ongeldig wachtwoord","errorTxtPwd":"Nieuw wachtwoord mag niet gelijk zijn aan huidig wachtwoord.","expand":"Uitvouwen","labelConfirm":"Wachtwoord bevestigen","labelCurrent":"Huidig wachtwoord","labelPwd":"Wachtwoord","successTxtConfirm":"De wachtwoorden zijn gelijk.\n","wordCloudContainer":"Container voor woordenwolk","details":"Details"},"__no":{"collapse":"Komprimer","confidenceLevelHigh":"Høy","confidenceLevelLow":"Lav","confidenceLevelMedium":"Middels","confidenceLevelOutOfBoundary":"Utenfor grensen","errorTxtConfirm":"Passordene samsvarer ikke.","errorTxtCurrent":"Ugyldig passord","errorTxtPwd":"Nytt passord kan ikke være likt gjeldende passord.","expand":"Utvid","labelConfirm":"Bekreft passord","labelCurrent":"Gjeldende passord","labelPwd":"Passord","successTxtConfirm":"Passordene samsvarer.","wordCloudContainer":"Ordskycontainer","details":"Detaljer"},"__pl":{"collapse":"Zwiń","confidenceLevelHigh":"Wysoki","confidenceLevelLow":"Niski","confidenceLevelMedium":"Średni","confidenceLevelOutOfBoundary":"Poza granicą","errorTxtConfirm":"Hasła nie zgadzają się.","errorTxtCurrent":"Niepoprawne hasło","errorTxtPwd":"Nowe hasło nie może być identyczne z obecnym.","expand":"Rozwiń","labelConfirm":"Potwierdź hasło","labelCurrent":"Obecne hasło","labelPwd":"Hasło","successTxtConfirm":"Hasła zgadzają się.","wordCloudContainer":"Kontener chmury słów","details":"Szczegóły"},"__pt":{"collapse":"Reduzir","confidenceLevelHigh":"Alta","confidenceLevelLow":"Baixa","confidenceLevelMedium":"Média","confidenceLevelOutOfBoundary":"Fora do limite","errorTxtConfirm":"As senhas não correspondem.","errorTxtCurrent":"Senha Inválida","errorTxtPwd":"A nova senha não pode corresponder à senha atual.","expand":"Expandir","labelConfirm":"Senha de Confirmação","labelCurrent":"Senha Atual:","labelPwd":"Senha","successTxtConfirm":"As senhas correspondem.","wordCloudContainer":"Contêiner de nuvem de palavras","details":"Detalhes"},"__pt-br":{"collapse":"Reduzir","confidenceLevelHigh":"Alta","confidenceLevelLow":"Baixa","confidenceLevelMedium":"Média","confidenceLevelOutOfBoundary":"Fora do limite","errorTxtConfirm":"As senhas não correspondem.","errorTxtCurrent":"Senha Inválida","errorTxtPwd":"A nova senha não pode corresponder à senha atual.","expand":"Expandir","labelConfirm":"Senha de Confirmação","labelCurrent":"Senha Atual:","labelPwd":"Senha","successTxtConfirm":"As senhas correspondem.","wordCloudContainer":"Contêiner de nuvem de palavras","details":"Detalhes"},"__ro":{"collapse":"Restrângere","confidenceLevelHigh":"Nivel ridicat","confidenceLevelLow":"Scăzut","confidenceLevelMedium":"Mediu","confidenceLevelOutOfBoundary":"În afara graniţelor","errorTxtConfirm":"Parolele nu se potrivesc.","errorTxtCurrent":"Parolă invalidă","errorTxtPwd":"Parola nouă nu poate fi identică cu parola curentă.","expand":"Expandare","labelConfirm":"Confirmaţi parola","labelCurrent":"Parola curentă","labelPwd":"Parolă","successTxtConfirm":"Parolele se potrivesc.","wordCloudContainer":"Container nor de cuvinte","details":"Detalii"},"__ru":{"collapse":"Свернуть","confidenceLevelHigh":"Высокий","confidenceLevelLow":"Низкий","confidenceLevelMedium":"Средний","confidenceLevelOutOfBoundary":"Вне границ","errorTxtConfirm":"Пароли не совпадают.","errorTxtCurrent":"Неправильный пароль","errorTxtPwd":"Новый пароль не должен совпадать с текущим паролем.","expand":"Развернуть","labelConfirm":"Подтверждение пароля","labelCurrent":"Текущий пароль","labelPwd":"Пароль","successTxtConfirm":"Пароли совпадают.","wordCloudContainer":"Контейнер облака слов","details":"Подробности"},"__sl":{"collapse":"Strni","confidenceLevelHigh":"Visoka","confidenceLevelLow":"Nizka","confidenceLevelMedium":"Srednje","confidenceLevelOutOfBoundary":"Zunaj meje","errorTxtConfirm":"Gesli se ne ujemata.","errorTxtCurrent":"Neveljavno geslo","errorTxtPwd":"Novo geslo se ne sme ujemati s trenutnim geslom.","expand":"Razširi","labelConfirm":"Potrditev gesla","labelCurrent":"Trenutno geslo","labelPwd":"Geslo","successTxtConfirm":"Gesli se ujemata.","wordCloudContainer":"Vsebnik besednega oblaka","details":"Podrobnosti"},"__sv":{"collapse":"Komprimera","confidenceLevelHigh":"Hög","confidenceLevelLow":"Låg","confidenceLevelMedium":"Medel","confidenceLevelOutOfBoundary":"Utanför gräns","errorTxtConfirm":"Lösenorden stämmer inte överens.","errorTxtCurrent":"Ogiltigt lösenord","errorTxtPwd":"Det nya lösenordet får inte vara samma som det aktuella lösenordet.","expand":"Expandera","labelConfirm":"Bekräfta lösenord","labelCurrent":"Aktuellt lösenord","labelPwd":"Lösenord","successTxtConfirm":"Lösenorden stämmer.","wordCloudContainer":"Ordmolnsbehållare","details":"Uppgifter"},"__th":{"collapse":"ยุบ","confidenceLevelHigh":"สูง","confidenceLevelLow":"ต่ำ","confidenceLevelMedium":"กลาง","confidenceLevelOutOfBoundary":"นอกขอบเขต","errorTxtConfirm":"รหัสผ่านไม่ตรง","errorTxtCurrent":"รหัสผ่านไม่ถูกต้อง","errorTxtPwd":"รหัสผ่านใหม่ไม่ตรงกับรหัสผ่านปัจจุบัน","expand":"ขยาย","labelConfirm":"ยืนยันรหัสผ่าน","labelCurrent":"รหัสผ่านปัจจุบัน","labelPwd":"รหัสผ่าน","successTxtConfirm":"รหัสผ่านตรงกัน","wordCloudContainer":"คอนเทนเนอร์ Word cloud","details":"รายละเอียด"},"__tr":{"collapse":"Daralt","confidenceLevelHigh":"Yüksek","confidenceLevelLow":"Düşük","confidenceLevelMedium":"Orta","confidenceLevelOutOfBoundary":"Sınırın dışında","errorTxtConfirm":"Parolalar eşleşmiyor.","errorTxtCurrent":"Geçersiz parola","errorTxtPwd":"Yeni parola geçerli parolayla eşleşemez.","expand":"Genişlet","labelConfirm":"Parolayı onayla","labelCurrent":"Geçerli parola","labelPwd":"Parola","successTxtConfirm":"Parolalar eşleşiyor.","wordCloudContainer":"Sözcük bulutu kapsayıcısı","details":"Ayrıntılar"},"__zh":{"collapse":"折叠","confidenceLevelHigh":"高","confidenceLevelLow":"低","confidenceLevelMedium":"中","confidenceLevelOutOfBoundary":"超出边界","errorTxtConfirm":"密码不匹配。","errorTxtCurrent":"密码无效","errorTxtPwd":"新密码与当前密码不匹配。","expand":"展开","labelConfirm":"确认密码","labelCurrent":"当前密码","labelPwd":"密码","successTxtConfirm":"密码匹配。","wordCloudContainer":"字云容器","details":"详细信息"},"__zh-cn":{"collapse":"折叠","confidenceLevelHigh":"高","confidenceLevelLow":"低","confidenceLevelMedium":"中","confidenceLevelOutOfBoundary":"超出边界","errorTxtConfirm":"密码不匹配。","errorTxtCurrent":"密码无效","errorTxtPwd":"新密码与当前密码不匹配。","expand":"展开","labelConfirm":"确认密码","labelCurrent":"当前密码","labelPwd":"密码","successTxtConfirm":"密码匹配。","wordCloudContainer":"字云容器","details":"详细信息"},"__zh-tw":{"collapse":"收合","confidenceLevelHigh":"高","confidenceLevelLow":"低","confidenceLevelMedium":"中","confidenceLevelOutOfBoundary":"超出界限","errorTxtConfirm":"密碼不符。","errorTxtCurrent":"無效的密碼","errorTxtPwd":"新密碼無法與現行密碼相符。","expand":"展開","labelConfirm":"確認密碼","labelCurrent":"現行密碼","labelPwd":"密碼","successTxtConfirm":"密碼相符。","wordCloudContainer":"文字雲儲存器","details":"詳細資料"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(29);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-color-ranged-number__c1{color:#00aa5e}.bi-common-color-ranged-number__c2{color:#ffb000}.bi-common-color-ranged-number__c3{color:#e62325}", ""]);

// exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(31);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-draggable{position:absolute;display:inline-block;cursor:move;padding:15px}.bi-common-draggable__innerContainer{display:inline-block;cursor:default}", ""]);

// exports


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EmptyState; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Modeling UI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



class EmptyState extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  render() {
    const {
      icon,
      iconSize,
      header,
      body,
      button,
      height,
      maxWidth
    } = this.props;
    const headerMarginTop = icon ? 3 : 0;
    const bodyMarginTop = header ? 1 : headerMarginTop;
    const buttonMarginTop = icon || header || body ? 3 : 0;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
      height: height,
      justifyContent: "center"
    }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Icon, {
      icon: icon,
      height: iconSize,
      width: iconSize
    }), header && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Header, {
      maxWidth: maxWidth,
      gutter: [headerMarginTop, 0, 0, 0]
    }, header), body && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Body, {
      maxWidth: maxWidth,
      gutter: [bodyMarginTop, 0, 0, 0]
    }, body), button && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Body, {
      maxWidth: maxWidth,
      gutter: [buttonMarginTop, 0, 0, 0]
    }, button));
  }

}

_defineProperty(EmptyState, "propTypes", {
  icon: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object,
  iconSize: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  header: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node]),
  body: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node]),
  button: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number]),
  maxWidth: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number])
});

_defineProperty(EmptyState, "defaultProps", {
  iconSize: 128,
  height: '100%',
  maxWidth: 300
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextIcon; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TextIcon_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35);
/* harmony import */ var _TextIcon_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_TextIcon_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/no-find-dom-node */

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







const FlexElement = ({
  tid,
  children,
  classNames,
  ...others
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["FlexItem"], _extends({
  className: classNames,
  textAlign: "center",
  "data-tid": tid
}, others), children);

FlexElement.propTypes = {
  tid: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  classNames: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  gutter: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.array, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number])
};
class TextIcon extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_container", void 0);

    _defineProperty(this, "_onClick", () => {
      const {
        onClick,
        onSelect
      } = this.props;
      onSelect && onSelect();
      onClick && onClick();
    });

    _defineProperty(this, "_onDoubleClick", () => {
      const {
        onDoubleClick,
        onConfirm
      } = this.props;
      onConfirm && onConfirm();
      onDoubleClick && onDoubleClick();
    });

    _defineProperty(this, "_onKeyDown", e => {
      const {
        onSelect,
        onKeyDown
      } = this.props;

      if (e.keyCode === 32 || e.keyCode === 13) {
        onSelect && onSelect();
      }

      onKeyDown && onKeyDown(e);
    });

    _defineProperty(this, "_isClickable", () => this.props.onSelect || this.props.onClick || this.props.onDoubleClick);
  }

  focus() {
    const containerDomNode = Object(react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"])(this._container);
    containerDomNode && containerDomNode.focus();
  }

  render() {
    const {
      className = '',
      isSelected,
      children,
      ...other
    } = this.props;
    const passThroughProps = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["omit"])(other, 'onSelect', 'onConfirm');

    const isClickable = this._isClickable();

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["Container"], _extends({
      className: Object(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["classnames"])('text-icon__button', {
        clickable: isClickable,
        selected: isSelected
      }),
      tabIndex: 0,
      role: isClickable ? 'button' : null
    }, passThroughProps, {
      onClick: this._onClick,
      onDoubleClick: this._onDoubleClick,
      onKeyDown: this._onKeyDown,
      ref: node => this._container = node
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["FlexLayout"], {
      justifyContent: "center",
      alignItems: "center",
      direction: "column",
      fullHeight: true,
      className: `text-icon ${className}`
    }, children));
  }

}

_defineProperty(TextIcon, "Header", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  gutter: [0, 0, 1, 0],
  classNames: "text-icon__header"
}, props)));

_defineProperty(TextIcon, "SubHeader", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  gutter: [0, 0, 1, 0],
  classNames: "text-icon__sub_header"
}, props)));

_defineProperty(TextIcon, "Body", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  classNames: "text-icon__body"
}, props)));

_defineProperty(TextIcon, "Icon", ({
  icon,
  gutter = [],
  ...other
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, {
  gutter: gutter
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["SVGIcon"], _extends({
  className: "text-icon__icon",
  iconId: icon && icon.id
}, other))));

_defineProperty(TextIcon, "propTypes", {
  className: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onConfirm: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  isSelected: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onDoubleClick: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func
});

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(36);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".text-icon__button{height:100%;border:2px solid transparent;padding-top:24px;padding-bottom:24px}.text-icon__button.is-clickable:hover{cursor:pointer;border:2px solid #2d74da}.text-icon__button.is-selected{border-color:#2d74da}.text-icon__button.is-focus{outline:none}.text-icon__header{font-size:1rem;font-weight:700;line-height:1.25rem;padding-bottom:8px}.text-icon__sub_header{line-height:1.25rem;padding-bottom:8px}.text-icon__body{font-size:.875rem;line-height:1.125rem}.text-icon__icon{fill:#00baa1}", ""]);

// exports


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js");

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/draggable_32.js");

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--down_32");

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--up_32");

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(42);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-expandable-item-container{display:flex;flex-flow:column;align-items:stretch;background-color:#f3f3f3}.bi-common-expandable-item-container.is-draggable{cursor:move}.bi-common-expandable-item-container.is-draggable .bi-common-expandable-item-container__nameLine__itemName{margin-left:8px}.bi-common-expandable-item-container:hover{background-color:#eaeaea}.bi-common-expandable-item-container__nameLine{height:40px;margin-left:8px;align-items:center}.bi-common-expandable-item-container__nameLine__draggable{align-items:center;margin-right:8px}.bi-common-expandable-item-container__nameLine__itemName{display:flex;font-family:\"IBM Plex Sans\",Helvetica,Arial,sans-serif;font-size:.875rem;font-weight:400;letter-spacing:.02rem;line-height:1.125rem;margin-right:8px}.bi-common-expandable-item-container__nameLine__itemName__requiredSymbol{color:#aa231f}.bi-common-expandable-item-container__nameLine__icon{margin:0 8px;width:16px;height:16px}.bi-common-expandable-item-container__nameLine__contextMenu{padding:0 8px;cursor:pointer}.bi-common-expandable-item-container__nameLine__contextMenu .bx--btn__icon{margin:0}.bi-common-expandable-item-container__nameLine__expandArrow{padding:0 8px;cursor:pointer}.bi-common-expandable-item-container__infoLine{font-family:\"IBM Plex Sans\",Helvetica,Arial,sans-serif;font-size:.75rem;font-weight:400;height:24px;letter-spacing:.04rem;line-height:1rem;margin:0 16px}.bi-common-expandable-item-container__body{padding:8px 0}", ""]);

// exports
exports.locals = {
	"itemContainerClassName": "\"bi-common-expandable-item-container\""
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-loading-dots{fill:#1f57a4;height:16px;width:16px}.bi-common-loading-dots circle{-webkit-animation:blink 1s infinite;-moz-animation:blink 1s infinite;-o-animation:blink 1s infinite;animation:blink 1s infinite}.bi-common-loading-dots circle:nth-child(2){-webkit-animation:blink 1s .3s infinite;-moz-animation:blink 1s .3s infinite;-o-animation:blink 1s .3s infinite;animation:blink 1s .3s infinite}.bi-common-loading-dots circle:nth-child(3){-webkit-animation:blink 1s .6s infinite;-moz-animation:blink 1s .6s infinite;-o-animation:blink 1s .6s infinite;animation:blink 1s .6s infinite}@-webkit-keyframes blink{0%{opacity:.25}50%{opacity:1}100%{opacity:.25}}@-moz-keyframes blink{0%{opacity:.25}50%{opacity:1}100%{opacity:.25}}@-o-keyframes blink{0%{opacity:.25}50%{opacity:1}100%{opacity:.25}}@keyframes blink{0%{opacity:.25}50%{opacity:1}100%{opacity:.25}}", ""]);

// exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-overlay{background-color:rgba(255,255,255,.95);position:absolute;top:0;left:0;justify-content:center;height:100%;width:100%}", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = require("d3");

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = require("d3-cloud");

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(50);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-word-cloud svg g:focus[tabindex]{outline:2px solid #2d74da}", ""]);

// exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-field-item{display:flex;flex-flow:column;padding-left:8px;align-items:stretch;background-color:#f3f3f3}.bi-common-field-item.is-draggable{cursor:move}.bi-common-field-item.is-draggable .bi-common-field-item__nameLine__fieldName{margin-left:8px}.bi-common-field-item:hover{background-color:#eaeaea}.bi-common-field-item.has-filters .bi-common-field-item__nameLine{height:32px}.bi-common-field-item.has-filters .bi-common-field-item__nameLine__draggable{align-self:flex-end}.bi-common-field-item__nameLine{height:40px;display:flex;flex-flow:row;align-items:center;font-size:.875rem;margin-right:8px}.bi-common-field-item__nameLine__draggable{display:flex;align-items:center;flex:0 0 auto}.bi-common-field-item__nameLine__fieldName{flex:1 1 auto;margin-right:8px;margin-left:24px}.bi-common-field-item__nameLine__icon{margin-right:8px;margin-left:8px;width:16px;height:16px;flex:0 0 auto}.bi-common-field-item__nameLine__actionMenu{display:flex;align-items:center;cursor:pointer;flex:0 0 auto}.bi-common-field-item__infoLine{font-size:.75rem;display:flex;justify-content:space-between;height:24px;margin-right:6px}.bi-common-field-item__infoLine__values{margin-left:24px;margin-right:8px;flex:0 1 auto}.bi-common-field-item__infoLine__badge{flex:0 0 auto;border-radius:100%;width:20px;height:20px;display:flex;align-items:center;justify-content:center;background-color:#343334;color:#fff}", ""]);

// exports


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/illustrations-js/unknown-warning_128.js");

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".mui-errorView .text-icon__header{font-size:1rem;color:#343334}.mui-errorView .text-icon__body{font-size:.875rem}", ""]);

// exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(8);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(10);

// EXTERNAL MODULE: ./src/common/utils/requireAMD.tsx
var requireAMD = __webpack_require__(11);

// EXTERNAL MODULE: ./src/common/components/AceEditor.scss
var components_AceEditor = __webpack_require__(13);

// CONCATENATED MODULE: ./src/common/components/AceEditor.tsx
var AceEditor_dec, AceEditor_class, AceEditor_class2, AceEditor_temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




 // This will import a ace object,and ace needs to be no-conflict version.

let AceEditor_AceEditor = (AceEditor_dec = Object(requireAMD["default"])({
  ace: 'ace/noconflict/ace'
}), AceEditor_dec(AceEditor_class = Object(requireAMD["mixinComponentDidLoadModules"])(AceEditor_class = (AceEditor_temp = AceEditor_class2 = class AceEditor extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_editor", void 0);

    _defineProperty(this, "_node", void 0);

    _defineProperty(this, "_id", Object(external_lodash_["uniqueId"])('__aceEditor_'));

    _defineProperty(this, "_ref", node => {
      this._node = node;
    });
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const oldProps = this.props;

    if (nextProps.setOptions !== oldProps.setOptions) {
      this._setOptions(nextProps.setOptions);
    }
  }

  componentWillUnmount() {
    if (this._editor) {
      this._editor.destroy();

      this._editor = null;
    }
  }

  componentDidLoadModules() {
    const {
      mode,
      activeTheme,
      theme,
      highContrastTheme,
      commands,
      focus,
      editorProps,
      aceConfig,
      value,
      onChange,
      onCursorChange,
      onTextSelectionChange,
      setOptions
    } = this.props;
    const {
      ace
    } = window;
    this._editor = ace.edit(this._id);
    Object(external_lodash_["forOwn"])(editorProps, (val, key) => {
      this._editor[key] = val;
    });
    Object(external_lodash_["forOwn"])(aceConfig, (val, key) => {
      ace.config.set(key, val);
    });

    if (mode) {
      this._editor.getSession().setMode(`ace/mode/${mode}`);
    }

    if (activeTheme) {
      this._editor.setTheme(`ace/theme/${activeTheme}`);
    }

    if (highContrastTheme) {
      this._editor.highContrastThemeOn = () => this._editor.setTheme(`ace/theme/${highContrastTheme}`);

      this._editor.highContrastThemeOff = () => this._editor.setTheme(`ace/theme/${theme}`);
    }

    this._editor.completers = []; // allow custom completers only

    this._editor.setValue(value != null ? value : '', -1);

    this._editor.on('change', () => onChange(this._editor.getValue()));

    this._editor.on('changeSelection', () => onTextSelectionChange(this._editor.session.getTextRange(this._editor.getSelectionRange())));

    const selection = this._editor.session.getSelection();

    selection.on('changeCursor', () => {
      const position = this._editor.getCursorPosition();

      const token = this._editor.session.getTokenAt(position.row, position.column);

      token && onCursorChange(token);
    }).bind(this);

    this._setOptions(setOptions);

    if (commands) {
      commands.forEach(command => {
        this._editor.commands.addCommand(command);
      });
    } // allow the browser to handle the tab key by changing the element


    this._editor.commands.bindKey('Tab', null);

    this._editor.commands.bindKey('Shift-Tab', null);

    this.props.getAceEditorRef && this.props.getAceEditorRef(this._editor);

    if (focus) {
      this.focus();
    }
  }

  focus() {
    this._editor && this._editor.focus();
  }

  _setOptions(options) {
    if (this._editor) {
      options && Object(external_lodash_["forOwn"])(options, (val, key) => {
        this._editor.setOption(key, val);
      });

      const textarea = this._node.querySelector('textarea');

      if (textarea) {
        if (options) {
          textarea.readOnly = !!options.readOnly;
          textarea.setAttribute('aria-readonly', String(!!options.readOnly));
        }

        textarea.setAttribute('aria-label', this.props.label || '');
      }
    }
  }

  render() {
    const {
      width,
      height
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      id: this._id,
      ref: this._ref,
      style: {
        width,
        height
      }
    });
  }

}, _defineProperty(AceEditor_class2, "propTypes", {
  mode: external_prop_types_default.a.string,
  focus: external_prop_types_default.a.bool,
  activeTheme: external_prop_types_default.a.string,
  theme: external_prop_types_default.a.string,
  highContrastTheme: external_prop_types_default.a.string,
  value: external_prop_types_default.a.string,
  commands: external_prop_types_default.a.array,
  setOptions: external_prop_types_default.a.object,
  aceConfig: external_prop_types_default.a.object,
  editorProps: external_prop_types_default.a.object,
  onChange: external_prop_types_default.a.func,
  onCursorChange: external_prop_types_default.a.func,
  onTextSelectionChange: external_prop_types_default.a.func,
  width: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number]),
  height: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number]),
  getAceEditorRef: external_prop_types_default.a.func,
  label: external_prop_types_default.a.string
}), _defineProperty(AceEditor_class2, "defaultProps", {
  width: '100%',
  height: '100%'
}), AceEditor_temp)) || AceEditor_class) || AceEditor_class);

// EXTERNAL MODULE: ./src/common/components/ActionStatus.scss
var components_ActionStatus = __webpack_require__(18);

// CONCATENATED MODULE: ./src/common/components/ActionStatus.tsx
function ActionStatus_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



class ActionStatus_ActionStatus extends external_react_["Component"] {
  render() {
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-actionStatus",
      "aria-live": this.props.mode
    }, this.props.status);
  }

}

ActionStatus_defineProperty(ActionStatus_ActionStatus, "propTypes", {
  mode: external_prop_types_default.a.oneOf(['off', 'polite', 'assertive']),
  status: external_prop_types_default.a.string
});

ActionStatus_defineProperty(ActionStatus_ActionStatus, "defaultProps", {
  mode: 'polite'
});
// EXTERNAL MODULE: external "@ba/ba-ui-carbon-toolkit"
var ba_ui_carbon_toolkit_ = __webpack_require__(12);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/illustrations-js/no-properties_128.js"
var no_properties_128_js_ = __webpack_require__(20);
var no_properties_128_js_default = /*#__PURE__*/__webpack_require__.n(no_properties_128_js_);

// EXTERNAL MODULE: ./src/common/components/PanelMessage.tsx
var PanelMessage = __webpack_require__(21);

// CONCATENATED MODULE: ./src/common/components/BeePanelMessage.tsx
function BeePanelMessage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





class BeePanelMessage_BeePanelMessage extends external_react_["Component"] {
  render() {
    return /*#__PURE__*/external_react_default.a.createElement(PanelMessage["default"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      iconId: no_properties_128_js_default.a.id,
      width: 128,
      height: 128
    }), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["VSpacer"], {
      size: 1
    }), this.props.children);
  }

}

BeePanelMessage_defineProperty(BeePanelMessage_BeePanelMessage, "propTypes", {
  children: external_prop_types_default.a.node
});
// EXTERNAL MODULE: ./src/nls/StringResource.js
var StringResource = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/amdi18n-loader!./src/common/nls/CommonResources.js
var CommonResources = __webpack_require__(27);
var CommonResources_default = /*#__PURE__*/__webpack_require__.n(CommonResources);

// CONCATENATED MODULE: ./src/common/nls/StringResource.js
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-common
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/


/* harmony default export */ var nls_StringResource = (new StringResource["default"](CommonResources_default.a));
// EXTERNAL MODULE: ./src/common/components/ColorRangedNumber.scss
var components_ColorRangedNumber = __webpack_require__(28);

// CONCATENATED MODULE: ./src/common/components/ColorRangedNumber.tsx
function ColorRangedNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





class ColorRangedNumber_ColorRangedNumber extends external_react_["Component"] {
  render() {
    const {
      value,
      ranges,
      decimal,
      predicate,
      className
    } = this.props;
    const range = ranges.find(r => predicate(value, r.range)) || {
      color: '',
      tooltip: nls_StringResource.get('confidenceLevelOutOfBoundary')
    };
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Tooltip"], {
      className: `${className} bi-common-color-ranged-number`,
      title: range.tooltip
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: `bi-common-color-ranged-number__${range.color}`
    }, `${(value * 100).toFixed(decimal)}%`));
  }

}

ColorRangedNumber_defineProperty(ColorRangedNumber_ColorRangedNumber, "propTypes", {
  value: external_prop_types_default.a.number.isRequired,
  ranges: external_prop_types_default.a.array,
  decimal: external_prop_types_default.a.number,
  className: external_prop_types_default.a.string,
  predicate: external_prop_types_default.a.func
});

ColorRangedNumber_defineProperty(ColorRangedNumber_ColorRangedNumber, "defaultProps", {
  decimal: 0,
  predicate: (value, [from, to]) => value > from && value <= to,
  ranges: [{
    range: [0.8, 1],
    color: 'c1',
    tooltip: nls_StringResource.get('confidenceLevelHigh')
  }, {
    range: [0.5, 0.8],
    color: 'c2',
    tooltip: nls_StringResource.get('confidenceLevelMedium')
  }, {
    range: [0, 0.5],
    color: 'c3',
    tooltip: nls_StringResource.get('confidenceLevelLow')
  }]
});
// EXTERNAL MODULE: ./src/common/components/draggable.scss
var components_draggable = __webpack_require__(30);

// CONCATENATED MODULE: ./src/common/components/draggable.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function draggable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




function draggable_draggable(position = {}, boundaryElement) {
  return function (ComponentClass) {
    class Draggable extends external_react_["Component"] {
      constructor(...args) {
        super(...args);

        draggable_defineProperty(this, "_startPositionX", 0);

        draggable_defineProperty(this, "_startPositionY", 0);

        draggable_defineProperty(this, "_endPositionX", 0);

        draggable_defineProperty(this, "_endPositionY", 0);

        draggable_defineProperty(this, "_el", void 0);

        draggable_defineProperty(this, "_closeDragElement", () => {
          // stop moving when mouse button is released:
          document.removeEventListener('mouseup', this._closeDragElement);
          document.removeEventListener('mousemove', this._elementDrag);
        });

        draggable_defineProperty(this, "_elementDrag", e => {
          const evt = e || window.event;
          evt.preventDefault();

          const boundaryRect = (boundaryElement || this._el.parentElement).getBoundingClientRect();

          const elementRect = this._el.getBoundingClientRect();

          this._startPositionX = this._endPositionX - evt.clientX;
          this._startPositionY = this._endPositionY - evt.clientY;
          const newTop = this._el.offsetTop - this._startPositionY;
          const newLeft = this._el.offsetLeft - this._startPositionX; // boundary check

          if (newTop > 0 && newTop + elementRect.height < boundaryRect.height) {
            this._el.style.top = `${newTop}px`;
            this._el.style.bottom = '';
            this._endPositionY = evt.clientY;
          }

          if (newLeft > 0 && newLeft + elementRect.width < boundaryRect.width) {
            this._el.style.left = `${newLeft}px`;
            this._el.style.right = '';
            this._endPositionX = evt.clientX;
          }
        });

        draggable_defineProperty(this, "_dragMouseDown", e => {
          const evt = e || window.event;
          evt.preventDefault();
          this._endPositionX = evt.clientX;
          this._endPositionY = evt.clientY;
          document.addEventListener('mouseup', this._closeDragElement);
          document.addEventListener('mousemove', this._elementDrag);
        });
      }

      componentWillUnmount() {
        this._closeDragElement();
      }

      render() {
        const passThroughProps = Object(external_lodash_["omit"])(this.props, 'draggableForwardRef');
        const {
          top,
          right,
          left,
          bottom
        } = position;
        return /*#__PURE__*/external_react_default.a.createElement("div", {
          className: "bi-common-draggable",
          onMouseDown: this._dragMouseDown,
          ref: el => this._el = el,
          style: {
            top,
            right,
            left,
            bottom
          }
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          onMouseDown: e => e.stopPropagation(),
          className: "bi-common-draggable__innerContainer"
        }, /*#__PURE__*/external_react_default.a.createElement(ComponentClass, _extends({}, passThroughProps, {
          ref: this.props.draggableForwardRef
        }))));
      }

    }

    draggable_defineProperty(Draggable, "propTypes", {
      draggableForwardRef: external_prop_types_default.a.any
    });

    draggable_defineProperty(Draggable, "WrappedComponent", void 0);

    Draggable.WrappedComponent = ComponentClass;
    return external_react_default.a.forwardRef((props, ref) => /*#__PURE__*/external_react_default.a.createElement(Draggable, _extends({}, props, {
      draggableForwardRef: ref
    })));
  };
}
// EXTERNAL MODULE: ./src/common/components/EmptyState.tsx
var EmptyState = __webpack_require__(32);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js"
var overflow_menu_vertical_32_js_ = __webpack_require__(37);
var overflow_menu_vertical_32_js_default = /*#__PURE__*/__webpack_require__.n(overflow_menu_vertical_32_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/draggable_32.js"
var draggable_32_js_ = __webpack_require__(38);
var draggable_32_js_default = /*#__PURE__*/__webpack_require__.n(draggable_32_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/chevron--down_32"
var chevron_down_32_ = __webpack_require__(39);
var chevron_down_32_default = /*#__PURE__*/__webpack_require__.n(chevron_down_32_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/chevron--up_32"
var chevron_up_32_ = __webpack_require__(40);
var chevron_up_32_default = /*#__PURE__*/__webpack_require__.n(chevron_up_32_);

// EXTERNAL MODULE: ./src/common/components/ExpandableItemContainer.scss
var components_ExpandableItemContainer = __webpack_require__(41);
var ExpandableItemContainer_default = /*#__PURE__*/__webpack_require__.n(components_ExpandableItemContainer);

// CONCATENATED MODULE: ./src/common/components/ExpandableItemContainer.tsx
function ExpandableItemContainer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */









/**
 * The common ExpandableItemContainer component
 */

const {
  getKeyName,
  keyNames
} = ba_ui_carbon_toolkit_["keyboardUtils"];
const itemContainerClassName = ExpandableItemContainer_default.a.itemContainerClassName.replace(/"/g, '');
class ExpandableItemContainer_ExpandableItemContainer extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    ExpandableItemContainer_defineProperty(this, "state", {
      expanded: this.props.initiallyExpanded
    });

    ExpandableItemContainer_defineProperty(this, "_onKeyDown", (e, onKeyDown) => {
      const {
        ENTER
      } = keyNames;

      switch (getKeyName(e)) {
        case ENTER:
          {
            onKeyDown && onKeyDown(e);
            break;
          }

        default:
          break;
      }
    });

    ExpandableItemContainer_defineProperty(this, "_onContextMenu", e => {
      e.stopPropagation();
      this.props.onContextMenuAction(e.pageX, e.pageY);
    });

    ExpandableItemContainer_defineProperty(this, "_toggleExpanded", e => {
      e.stopPropagation();
      this.props.onExpandAction && this.props.onExpandAction(!this.state.expanded);
      this.setState(state => ({
        expanded: !state.expanded
      }));
    });
  }

  _renderExtendedInfo() {
    const {
      extendedInfo
    } = this.props;

    if (extendedInfo) {
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        className: `${itemContainerClassName}__infoLine`
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        className: `${itemContainerClassName}__infoLine__values`
      }, extendedInfo));
    }
  }

  _renderExpandableContent() {
    const {
      children
    } = this.props;
    return this.state.expanded && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "column",
      className: `${itemContainerClassName}__body`
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Collapse"], {
      hasNestedCollapse: true,
      forceInitialAnimation: true,
      autoUnmount: true,
      isOpened: this.state.expanded,
      className: `${itemContainerClassName}__body__collapse`
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      onClick: e => {
        e.stopPropagation();
      },
      onKeyDown: e => {
        e.stopPropagation();
      }
    }, children)));
  }

  render() {
    const {
      label,
      className,
      draggable,
      expandable,
      itemGraphics,
      onContextMenuAction,
      showActionMenu,
      required
    } = this.props;
    const {
      expanded
    } = this.state;
    const classNames = Object(ba_ui_carbon_toolkit_["classnames"])(itemContainerClassName, {
      'is-draggable': draggable,
      'is-required': required
    });
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "column",
      className: className ? `${classNames} ${className}` : classNames,
      tabIndex: "0"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      className: `${itemContainerClassName}__nameLine`
    }, draggable && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      className: `${itemContainerClassName}__nameLine__draggable`
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      size: "small",
      iconId: draggable_32_js_default.a.id
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      shrink: true,
      basis: "auto",
      className: `${itemContainerClassName}__nameLine__itemName`
    }, label, required && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: `${itemContainerClassName}__nameLine__itemName__requiredSymbol`
    }, "*")), itemGraphics && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      className: `${itemContainerClassName}__nameLine__icon`
    }, itemGraphics), expandable && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      className: `${itemContainerClassName}__nameLine__expandArrow`,
      tabIndex: 0,
      onKeyPress: e => this._onKeyDown(e, this._toggleExpanded),
      onClick: this._toggleExpanded
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Tooltip"], {
      title: expanded ? nls_StringResource.get('collapse') : nls_StringResource.get('expand')
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      size: "small",
      iconId: expanded ? chevron_up_32_default.a.id : chevron_down_32_default.a.id
    }))), showActionMenu && onContextMenuAction && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      className: `${itemContainerClassName}__nameLine__contextMenu`,
      "data-tid": `${itemContainerClassName}__nameLine__contextMenu`,
      button: false,
      intent: "",
      size: "small",
      onClick: this._onContextMenu,
      onKeyPress: e => this._onKeyDown(e, this._onContextMenu),
      variant: "inline",
      tabIndex: 0,
      icon: /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
        pad: true,
        iconId: overflow_menu_vertical_32_js_default.a.id,
        size: "small"
      })
    })))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, this._renderExtendedInfo()), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0, 2]
    }, this._renderExpandableContent()));
  }

}

ExpandableItemContainer_defineProperty(ExpandableItemContainer_ExpandableItemContainer, "propTypes", {
  className: external_prop_types_default.a.string,
  label: external_prop_types_default.a.node.isRequired,
  extendedInfo: external_prop_types_default.a.node,
  itemGraphics: external_prop_types_default.a.node,
  draggable: external_prop_types_default.a.bool,
  initiallyExpanded: external_prop_types_default.a.bool,
  required: external_prop_types_default.a.bool,
  showActionMenu: external_prop_types_default.a.bool,
  onExpandAction: external_prop_types_default.a.func,
  onContextMenuAction: external_prop_types_default.a.func
});

ExpandableItemContainer_defineProperty(ExpandableItemContainer_ExpandableItemContainer, "defaultProps", {
  className: '',
  extendedInfo: null,
  itemGraphics: null,
  draggable: true,
  expandable: true,
  initiallyExpanded: false,
  required: false,
  showActionMenu: true,
  onExpandAction: () => {},
  onContextMenuAction: () => {}
});
// CONCATENATED MODULE: ./src/common/components/ProgressPanelMessage.tsx
function ProgressPanelMessage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




const DEFAULT_DELAY = 250;
class ProgressPanelMessage_ProgressPanelMessage extends external_react_["Component"] {
  render() {
    const {
      children,
      ...other
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(PanelMessage["default"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ProgressIndicator"], other), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["VSpacer"], {
      size: 1
    }), children);
  }

}

ProgressPanelMessage_defineProperty(ProgressPanelMessage_ProgressPanelMessage, "propTypes", {
  children: external_prop_types_default.a.node
});

/* harmony default export */ var components_ProgressPanelMessage = (Object(ba_ui_carbon_toolkit_["delayMount"])(DEFAULT_DELAY)(ProgressPanelMessage_ProgressPanelMessage));
// CONCATENATED MODULE: ./src/common/components/Loadable.tsx
function Loadable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



class Loadable_Loadable extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    Loadable_defineProperty(this, "state", {
      ResolvedComponent: null
    });
  }

  componentDidMount() {
    this.props.resolver().then(Comp => {
      this.setState({
        ResolvedComponent: Comp
      });
    });
  }

  render() {
    const {
      ResolvedComponent
    } = this.state;
    return ResolvedComponent ? this.props.children(ResolvedComponent) : /*#__PURE__*/external_react_default.a.createElement(components_ProgressPanelMessage, null);
  }

}

Loadable_defineProperty(Loadable_Loadable, "propTypes", {
  resolver: external_prop_types_default.a.func.isRequired,
  children: external_prop_types_default.a.func.isRequired
});
// EXTERNAL MODULE: ./src/common/components/LoadingDots.scss
var components_LoadingDots = __webpack_require__(43);

// CONCATENATED MODULE: ./src/common/components/LoadingDots.tsx
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


class LoadingDots_LoadingDots extends external_react_["Component"] {
  render() {
    return /*#__PURE__*/external_react_default.a.createElement("svg", {
      className: "bi-common-loading-dots",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      id: "loading-dots_16"
    }, /*#__PURE__*/external_react_default.a.createElement("circle", {
      className: "bi-common-loading-dot",
      cx: "2",
      cy: "8",
      r: "2"
    }), /*#__PURE__*/external_react_default.a.createElement("circle", {
      className: "bi-common-loading-dot",
      cx: "8",
      cy: "8",
      r: "2"
    }), /*#__PURE__*/external_react_default.a.createElement("circle", {
      className: "bi-common-loading-dot",
      cx: "14",
      cy: "8",
      r: "2"
    }));
  }

}
// EXTERNAL MODULE: ./src/common/components/Overlay.scss
var components_Overlay = __webpack_require__(45);

// CONCATENATED MODULE: ./src/common/components/Overlay.tsx
function Overlay_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class Overlay_Overlay extends external_react_["Component"] {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      justifyContent: "center",
      className: "bi-common-overlay"
    }, children);
  }

}

Overlay_defineProperty(Overlay_Overlay, "propTypes", {
  children: external_prop_types_default.a.node
});
// EXTERNAL MODULE: ./src/common/components/TextIcon.tsx
var TextIcon = __webpack_require__(33);

// EXTERNAL MODULE: external "d3"
var external_d3_ = __webpack_require__(47);

// EXTERNAL MODULE: external "d3-cloud"
var external_d3_cloud_ = __webpack_require__(48);
var external_d3_cloud_default = /*#__PURE__*/__webpack_require__.n(external_d3_cloud_);

// EXTERNAL MODULE: ./src/common/components/WordCloud.scss
var components_WordCloud = __webpack_require__(49);

// CONCATENATED MODULE: ./src/common/components/WordCloud.tsx
function WordCloud_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







const DEFAULT_OPACITY = 0.4;
const HOVER_OPACITY = 0.7;
const SELECTED_OPACITY = 0.9;
class WordCloud_WordCloud extends external_react_["Component"] {
  constructor(props) {
    super(props);

    WordCloud_defineProperty(this, "_debouncedResize", void 0);

    WordCloud_defineProperty(this, "_currentFocusIdx", void 0);

    WordCloud_defineProperty(this, "_clickIgnore", void 0);

    WordCloud_defineProperty(this, "_clickTimerID", void 0);

    WordCloud_defineProperty(this, "_withNewWords", void 0);

    WordCloud_defineProperty(this, "_el", void 0);

    WordCloud_defineProperty(this, "_canvas", void 0);

    WordCloud_defineProperty(this, "_cloud", void 0);

    WordCloud_defineProperty(this, "_words", void 0);

    WordCloud_defineProperty(this, "_tailEl", void 0);

    WordCloud_defineProperty(this, "_init", () => {
      const width = this._el.offsetWidth;
      const height = this._el.offsetHeight;
      this._canvas = external_d3_["select"](this._el).append('svg').attr('width', '100%').attr('height', '100%').append('g').attr('transform', `translate(${width / 2},${height / 2})`);
      this._cloud = external_d3_cloud_default()().size([width, height]).padding(this.props.padding).rotate(0).font(this.props.fontFamily).fontSize(d => d.size).on('end', this._update);

      this._start();
    });

    WordCloud_defineProperty(this, "_resize", () => {
      this._cloud.stop();

      while (this._el && this._el.firstChild) {
        this._el.removeChild(this._el.firstChild);
      }

      this._init();
    });

    WordCloud_defineProperty(this, "_fontWeight", d => d.selected ? 'bold' : 'normal');

    WordCloud_defineProperty(this, "_start", () => {
      // need a copy of words, since it will be mutated by D3 wordcloud after.
      this._words = Object(external_lodash_["cloneDeep"])(this.props.words);

      this._cloud.words(this._words).start();
    });

    WordCloud_defineProperty(this, "_fill", d => {
      const {
        colorRange
      } = this.props;
      return external_d3_["scaleQuantize"]().domain([0, colorRange.length - 1]).range(colorRange)(d.sourceIdx % colorRange.length);
    });

    WordCloud_defineProperty(this, "_opacity", d => d.selected || !this.props.selectedWords.length ? SELECTED_OPACITY : DEFAULT_OPACITY);

    WordCloud_defineProperty(this, "_getNextFocus", isBackward => {
      const {
        length
      } = this.props.words;
      let nextFocusIdx = this._currentFocusIdx;

      if (isBackward) {
        nextFocusIdx -= 1;

        if (nextFocusIdx < 0) {
          nextFocusIdx = length - 1;
        }
      } else {
        nextFocusIdx += 1;

        if (nextFocusIdx >= length) {
          nextFocusIdx = 0;
        }
      }

      return nextFocusIdx;
    });

    WordCloud_defineProperty(this, "_keydown", (event, d) => {
      // right arrow
      if (event.keyCode === 39) {
        this._setFocus(this._getNextFocus());
      } // left arrow


      if (event.keyCode === 37) {
        this._setFocus(this._getNextFocus(true));
      } // tab


      if (event.keyCode === 9) {
        this._tailEl.focus();
      } // shift tab


      if (event.shiftKey && event.keyCode === 9) {
        this._el.focus();
      } // space


      if (event.keyCode === 32) {
        this.props.onWordClick(d);
      }
    });

    WordCloud_defineProperty(this, "_setFocus", idx => {
      if (idx != null) {
        this._currentFocusIdx = idx;
      }

      const nodes = this._canvas.selectAll('g').nodes();

      const currentNode = nodes[this._currentFocusIdx];
      currentNode && currentNode.focus && currentNode.focus();
    });

    WordCloud_defineProperty(this, "_click", (event, d) => {
      // create mechanism to ignore 'click' event if we also received 'dblclick'
      this._clickTimerID = window.setTimeout(() => {
        if (!this._clickIgnore) {
          const idx = this._words.indexOf(d);

          this._setFocus(idx);

          this.props.onWordClick(d);
        }

        this._clickIgnore = false;
      }, 300
      /* arbitrary */
      );
    });

    WordCloud_defineProperty(this, "_dblclick", (event, d) => {
      // ignore 'click' event
      clearTimeout(this._clickTimerID);
      this._clickIgnore = true; // mimic 'click' event

      const idx = this._words.indexOf(d);

      this._setFocus(idx);

      this.props.onWordClick(d);
    });

    WordCloud_defineProperty(this, "_update", () => {
      this._words = this._words.map((word, idx) => ({ ...word,
        ...this.props.words[idx]
      }));

      const allWords = this._canvas.selectAll('g').data(this._words, d => {
        d.selected = this.props.selectedWords.indexOf(d.text) > -1;
        return [d.text, d.size];
      });

      const group = allWords.enter().append('g');
      const self = this;
      group.append('title').text(d => d.title);
      group.append('text');
      group.merge(allWords).select('text').style('fill', this._fill).style('font-family', this.props.fontFamily).style('font-weight', this._fontWeight).style('font-size', d => `${d.size}px`).attr('text-anchor', 'middle').attr('transform', d => `translate(${d.x}, ${d.y})`).style('cursor', 'pointer').style('opacity', this._opacity).text(d => d.text).on('mouseover', function (event, d) {
        if (!d.selected) {
          external_d3_["select"](this).transition().style('opacity', HOVER_OPACITY);
        }
      }).on('mouseout', function (event, d) {
        if (!d.selected) {
          external_d3_["select"](this).transition().style('opacity', self._opacity); // eslint-disable-line
        }
      });
      group.attr('tabindex', 0).on('keydown', this._keydown).on('click', this._click).on('dblclick', this._dblclick) // To make sure the correct keywords gets the focus when the init tabbing launched on the word cloud
      .on('focus', () => this._setFocus());
      allWords.exit().remove();
    });

    this._debouncedResize = Object(external_lodash_["debounce"])(this._resize, 1000);
    this._currentFocusIdx = 0;
    this._clickIgnore = false;
    this._clickTimerID = 0;
  }

  componentDidMount() {
    window.addEventListener('resize', this._debouncedResize);

    this._init();
  }

  componentDidUpdate() {
    this._withNewWords ? this._start() : this._update();
  }

  componentWillUnmount() {
    this._el = null;
    window.removeEventListener('resize', this._debouncedResize);
  }

  getSnapshotBeforeUpdate(prevProps) {
    this._withNewWords = prevProps.words.length !== this.props.words.length;
  }

  render() {
    const {
      width,
      height
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement("div", {
      tabIndex: 0,
      ref: el => this._el = el,
      style: {
        width,
        height
      },
      className: "bi-common-word-cloud",
      "aria-label": nls_StringResource.get('wordCloudContainer')
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      tabIndex: 0,
      ref: el => this._tailEl = el,
      style: {
        width: 0,
        height: 0,
        outline: 'none'
      }
    }));
  }

}

WordCloud_defineProperty(WordCloud_WordCloud, "propTypes", {
  words: external_prop_types_default.a.array.isRequired,
  colorRange: external_prop_types_default.a.array.isRequired,
  fontFamily: external_prop_types_default.a.array.isRequired,
  selectedWords: external_prop_types_default.a.array,
  onWordClick: external_prop_types_default.a.func,
  width: external_prop_types_default.a.number,
  height: external_prop_types_default.a.number,
  padding: external_prop_types_default.a.number
});

WordCloud_defineProperty(WordCloud_WordCloud, "defaultProps", {
  width: '100%',
  height: '100%',
  selectedWords: [],
  padding: 2
});
// EXTERNAL MODULE: ./src/common/components/FieldItem.scss
var components_FieldItem = __webpack_require__(51);

// CONCATENATED MODULE: ./src/common/components/FieldItem.tsx
function FieldItem_extends() { FieldItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FieldItem_extends.apply(this, arguments); }

function FieldItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







/**
 * The common FieldItem component
 */

class FieldItem_FieldItem extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FieldItem_defineProperty(this, "domNode", void 0);
  }

  getDOMNode() {
    return this.domNode;
  }

  _renderFilterStringAndNumber(filterInfo) {
    const {
      filterString,
      numberOfFilterItems
    } = filterInfo || {};

    if (filterString) {
      return /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "bi-common-field-item__infoLine"
      }, /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "bi-common-field-item__infoLine__values"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
        value: filterString
      })), numberOfFilterItems ? /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "bi-common-field-item__infoLine__badge"
      }, numberOfFilterItems) : null);
    }

    return null;
  }

  render() {
    const {
      fieldName,
      className,
      draggable,
      showActionMenu,
      onOpenActionMenu,
      fieldGraphics,
      filterInfo
    } = this.props;
    const forwardedProps = Object(external_lodash_["omit"])(this.props, 'className', 'children', 'fieldName', 'draggable', 'showActionMenu', 'onOpenActionMenu', 'fieldGraphics', 'filterInfo');
    const hasFilters = !!(filterInfo && filterInfo.filterString);
    const classNames = Object(ba_ui_carbon_toolkit_["classnames"])('bi-common-field-item', {
      'has-filters': hasFilters,
      'is-draggable': draggable
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", FieldItem_extends({
      className: className ? `${classNames} ${className}` : classNames,
      "aria-label": fieldName,
      tabIndex: "0",
      ref: node => {
        this.domNode = node;
      }
    }, forwardedProps), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-field-item__nameLine"
    }, draggable && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-field-item__nameLine__draggable"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      size: "small",
      iconId: draggable_32_js_default.a.id
    })), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-field-item__nameLine__fieldName"
    }, hasFilters ? /*#__PURE__*/external_react_default.a.createElement("div", null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      location: "middle",
      style: {
        fontWeight: 'bold'
      },
      value: fieldName
    })) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      location: "middle",
      style: {
        fontWeight: 'normal'
      },
      value: fieldName
    })), fieldGraphics && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-field-item__nameLine__icon"
    }, fieldGraphics), showActionMenu && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-field-item__nameLine__actionMenu",
      tabIndex: 0,
      onKeyPress: e => {
        e.stopPropagation();
        onOpenActionMenu(e);
      },
      onClick: e => {
        e.stopPropagation();
        onOpenActionMenu(e);
      }
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      size: "small",
      iconId: overflow_menu_vertical_32_js_default.a.id
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "actionmenu"
    }))), this._renderFilterStringAndNumber(filterInfo));
  }

}

FieldItem_defineProperty(FieldItem_FieldItem, "propTypes", {
  className: external_prop_types_default.a.string,
  fieldName: external_prop_types_default.a.string.isRequired,
  draggable: external_prop_types_default.a.bool,
  showActionMenu: external_prop_types_default.a.bool,
  onOpenActionMenu: external_prop_types_default.a.func,
  fieldGraphics: external_prop_types_default.a.node,
  filterInfo: external_prop_types_default.a.object
});

FieldItem_defineProperty(FieldItem_FieldItem, "defaultProps", {
  className: '',
  draggable: true,
  showActionMenu: true,
  onOpenActionMenu: () => {},
  fieldGraphics: null,
  filterInfo: null
});
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(34);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);

// EXTERNAL MODULE: external "react-dnd"
var external_react_dnd_ = __webpack_require__(53);

// CONCATENATED MODULE: ./src/common/components/sortableItem.tsx
function sortableItem_extends() { sortableItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sortableItem_extends.apply(this, arguments); }

function sortableItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





class sortableItem_SortableDragLayer extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    sortableItem_defineProperty(this, "_div", void 0);

    sortableItem_defineProperty(this, "_ref", div => {
      this._div = div;
    });
  }

  componentDidMount() {
    this._div.appendChild(this.props.itemProps.node);
  }

  render() {
    const {
      currentOffset,
      itemProps
    } = this.props;
    const {
      x,
      y
    } = currentOffset;
    const transform = `translate(${x}px, ${y}px)`;
    const {
      boundingRect
    } = itemProps;
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      ref: this._ref,
      style: {
        transform,
        width: boundingRect.width,
        height: boundingRect.height
      }
    });
  }

}

sortableItem_defineProperty(sortableItem_SortableDragLayer, "propTypes", {
  itemProps: external_prop_types_default.a.object.isRequired,
  currentOffset: external_prop_types_default.a.object.isRequired
});

function sortableItem({
  dropTargetMethods = {},
  dragSourceMethods = {},
  type = Object(external_lodash_["uniqueId"])('SORTABLE_ITEM')
}) {
  const sortableHoc = function (Item) {
    var _dec, _dec2, _class, _class2, _temp;

    const hover = function (props, monitor, component) {
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = external_react_dom_default.a.findDOMNode(component).getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top; // Dragging downwards

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      } // Dragging upwards


      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      props.moveItem(dragIndex, hoverIndex);
      monitor.getItem().index = hoverIndex;
      dropTargetMethods.hover && dropTargetMethods.hover(props, monitor, component);
    };

    const beginDrag = function (props, monitor, component) {
      const node = external_react_dom_default.a.findDOMNode(component);
      const boundingRect = node.getBoundingClientRect();
      const dragProps = {
        index: props.index,
        boundingRect
      };

      if (dragSourceMethods.beginDrag) {
        Object.assign(dragProps, dragSourceMethods.beginDrag(props, monitor, component));
      }

      if (!dragProps.dragLayerRenderer) {
        dragProps.node = node.cloneNode(true);

        dragProps.dragLayerRenderer = props => /*#__PURE__*/external_react_default.a.createElement(sortableItem_SortableDragLayer, props);
      }

      return dragProps;
    };

    let SortableItem = (_dec = Object(external_react_dnd_["DropTarget"])(type, { ...dropTargetMethods,
      hover
    }, (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver()
    })), _dec2 = Object(external_react_dnd_["DragSource"])(type, { ...dragSourceMethods,
      beginDrag
    }, (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging()
    })), _dec(_class = _dec2(_class = (_temp = _class2 = class SortableItem extends external_react_["Component"] {
      constructor(...args) {
        super(...args);

        sortableItem_defineProperty(this, "_node", void 0);

        sortableItem_defineProperty(this, "_onKeyDown", e => {
          const {
            keyCode,
            altKey,
            target
          } = e;
          const {
            index,
            length,
            moveItem
          } = this.props;
          let moved = false;

          if (length != null) {
            if (keyCode === 38 && index > 0) {
              // up arrow
              moveItem(index, altKey ? 0 : index - 1);
              moved = true;
            } else if (keyCode === 40 && index !== length - 1) {
              // down arrow
              moveItem(index, altKey ? length - 1 : index + 1);
              moved = true;
            }

            if (moved) {
              e.preventDefault();
              target.scrollIntoView(false);
            }
          }
        });

        sortableItem_defineProperty(this, "_connectToDnD", ref => {
          const {
            connectDragSource,
            connectDropTarget
          } = this.props;
          const node = external_react_dom_default.a.findDOMNode(ref);
          this._node = node;
          connectDropTarget(node);
          connectDragSource(node, {
            restrictToYAxis: true
          });
        });
      }

      componentDidMount() {
        this._node.addEventListener('keydown', this._onKeyDown);
      }

      componentWillUnmount() {
        this._node.removeEventListener('keydown', this._onKeyDown);
      }

      render() {
        const passThroughProps = Object(external_lodash_["omit"])(this.props, 'connectDragSource', 'connectDropTarget');
        return /*#__PURE__*/external_react_default.a.createElement(Item, sortableItem_extends({}, passThroughProps, {
          ref: this._connectToDnD
        }));
      }

    }, sortableItem_defineProperty(_class2, "propTypes", {
      index: external_prop_types_default.a.number,
      length: external_prop_types_default.a.number,
      moveItem: external_prop_types_default.a.func,
      connectDragSource: external_prop_types_default.a.func,
      connectDropTarget: external_prop_types_default.a.func
    }), _temp)) || _class) || _class);
    return SortableItem;
  };

  return typeof arguments[0] === 'object' ? sortableHoc : sortableHoc(arguments[0]);
}
// EXTERNAL MODULE: external "@ba/ba-graphics/dist/illustrations-js/unknown-warning_128.js"
var unknown_warning_128_js_ = __webpack_require__(54);
var unknown_warning_128_js_default = /*#__PURE__*/__webpack_require__.n(unknown_warning_128_js_);

// EXTERNAL MODULE: ./src/common/components/ErrorView.scss
var components_ErrorView = __webpack_require__(55);

// CONCATENATED MODULE: ./src/common/components/withErrorHandling.tsx
function withErrorHandling_extends() { withErrorHandling_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return withErrorHandling_extends.apply(this, arguments); }

function withErrorHandling_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class withErrorHandling_ErrorDialogPreview extends external_react_["Component"] {
  render() {
    const {
      onClose,
      ...other
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"], {
      onClose: () => onClose()
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Header, null, nls_StringResource.get('reactErrorTrace')), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Body, null, /*#__PURE__*/external_react_default.a.createElement(withErrorHandling_ErrorDetails, other)), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Footer, null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Button, {
      primary: true,
      label: nls_StringResource.get('ok'),
      onClick: () => onClose()
    })));
  }

}

withErrorHandling_defineProperty(withErrorHandling_ErrorDialogPreview, "propTypes", {
  onClose: external_prop_types_default.a.func
});

class withErrorHandling_ErrorDetails extends external_react_["Component"] {
  render() {
    const {
      error,
      errorInfo
    } = this.props;
    const value = `${error.stack}\n\n React Render Trace: ${errorInfo.componentStack}`;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["CodeSnippet"], {
      value: value,
      style: {
        height: '400px',
        overflow: 'auto'
      }
    });
  }

}

withErrorHandling_defineProperty(withErrorHandling_ErrorDetails, "propTypes", {
  error: external_prop_types_default.a.any,
  errorInfo: external_prop_types_default.a.any
});

class withErrorHandling_ErrorView extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    withErrorHandling_defineProperty(this, "state", {
      showDetails: false
    });
  }

  render() {
    const {
      showDetails
    } = this.state;
    const {
      bodyText,
      headerText,
      tryAgain
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(TextIcon["default"], {
      className: "mui-errorView"
    }, /*#__PURE__*/external_react_default.a.createElement(TextIcon["default"].Icon, {
      width: "128",
      height: "128",
      icon: unknown_warning_128_js_default.a
    }), /*#__PURE__*/external_react_default.a.createElement(TextIcon["default"].Header, null, headerText || nls_StringResource.get('reactErrorHeader')), /*#__PURE__*/external_react_default.a.createElement(TextIcon["default"].Body, null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Paragraph"], {
      style: {
        textAlign: 'center'
      }
    }, bodyText || nls_StringResource.get('reactError')), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Link"], {
      onClick: () => this.setState(state => ({
        showDetails: !state.showDetails
      }))
    }, nls_StringResource.get('reactErrorDetails')), tryAgain && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      gutter: [3]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      intent: "primary",
      "data-tid": "tryAgainButton",
      label: nls_StringResource.get('tryAgain'),
      title: nls_StringResource.get('tryAgain'),
      "aria-label": nls_StringResource.get('tryAgain'),
      onClick: this.props.tryAgain
    })))), showDetails && /*#__PURE__*/external_react_default.a.createElement(withErrorHandling_ErrorDialogPreview, withErrorHandling_extends({}, this.props, {
      onClose: () => this.setState({
        showDetails: false
      })
    })));
  }

}

withErrorHandling_defineProperty(withErrorHandling_ErrorView, "propTypes", {
  headerText: external_prop_types_default.a.string,
  bodyText: external_prop_types_default.a.string,
  tryAgain: external_prop_types_default.a.func
});

class withErrorHandling_ErrorToast extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    withErrorHandling_defineProperty(this, "state", {
      showDetails: false
    });
  }

  componentDidMount() {
    this.props.showToast(nls_StringResource.get('reactError'), {
      type: 'error',
      btnLabel: nls_StringResource.get('details'),
      preventDuplicates: true,
      callback: () => this.setState({
        showDetails: true
      })
    });
  }

  render() {
    return this.state.showDetails ? /*#__PURE__*/external_react_default.a.createElement(withErrorHandling_ErrorDialogPreview, withErrorHandling_extends({}, this.props, {
      onClose: () => this.setState({
        showDetails: false
      })
    })) : null;
  }

}

function withErrorHandling({
  showToast,
  onCatch,
  errorProps
} = {}) {
  return function (Comp) {
    return class ErrorHandler extends external_react_["Component"] {
      constructor(...args) {
        super(...args);

        withErrorHandling_defineProperty(this, "state", {
          error: null
        });

        withErrorHandling_defineProperty(this, "_caught", void 0);
      }

      /* eslint-disable camelcase */
      UNSAFE_componentWillReceiveProps() {
        if (this._caught) {
          this.setState({
            error: null
          });
          this._caught = false;
        }
      }

      componentDidCatch(error, errorInfo) {
        this.setState({
          error: {
            error,
            errorInfo
          }
        }, () => this._caught = true);
        onCatch && onCatch(this.props, error, errorInfo);
      }

      render() {
        const {
          tryAgain,
          ...other
        } = errorProps && errorProps(this.props) || {};

        const doTryAgain = () => {
          tryAgain();
          this.setState({
            error: null
          });
        };

        if (this.state.error) {
          if (showToast) {
            return /*#__PURE__*/external_react_default.a.createElement(withErrorHandling_ErrorToast, withErrorHandling_extends({
              showToast: showToast
            }, this.state.error, {
              onClose: () => this.setState({
                error: null
              })
            }));
          }

          return /*#__PURE__*/external_react_default.a.createElement(withErrorHandling_ErrorView, withErrorHandling_extends({}, this.state.error, other, {
            tryAgain: tryAgain && doTryAgain
          }));
        }

        return /*#__PURE__*/external_react_default.a.createElement(Comp, this.props);
      }

    };
  };
}
// CONCATENATED MODULE: ./src/common/components/index.ts
/* concated harmony reexport AceEditor */__webpack_require__.d(__webpack_exports__, "AceEditor", function() { return AceEditor_AceEditor; });
/* concated harmony reexport ActionStatus */__webpack_require__.d(__webpack_exports__, "ActionStatus", function() { return ActionStatus_ActionStatus; });
/* concated harmony reexport BeePanelMessage */__webpack_require__.d(__webpack_exports__, "BeePanelMessage", function() { return BeePanelMessage_BeePanelMessage; });
/* concated harmony reexport ColorRangedNumber */__webpack_require__.d(__webpack_exports__, "ColorRangedNumber", function() { return ColorRangedNumber_ColorRangedNumber; });
/* concated harmony reexport draggable */__webpack_require__.d(__webpack_exports__, "draggable", function() { return draggable_draggable; });
/* concated harmony reexport EmptyState */__webpack_require__.d(__webpack_exports__, "EmptyState", function() { return EmptyState["default"]; });
/* concated harmony reexport ExpandableItemContainer */__webpack_require__.d(__webpack_exports__, "ExpandableItemContainer", function() { return ExpandableItemContainer_ExpandableItemContainer; });
/* concated harmony reexport Loadable */__webpack_require__.d(__webpack_exports__, "Loadable", function() { return Loadable_Loadable; });
/* concated harmony reexport LoadingDots */__webpack_require__.d(__webpack_exports__, "LoadingDots", function() { return LoadingDots_LoadingDots; });
/* concated harmony reexport Overlay */__webpack_require__.d(__webpack_exports__, "Overlay", function() { return Overlay_Overlay; });
/* concated harmony reexport PanelMessage */__webpack_require__.d(__webpack_exports__, "PanelMessage", function() { return PanelMessage["default"]; });
/* concated harmony reexport ProgressPanelMessage */__webpack_require__.d(__webpack_exports__, "ProgressPanelMessage", function() { return components_ProgressPanelMessage; });
/* concated harmony reexport sortableItem */__webpack_require__.d(__webpack_exports__, "sortableItem", function() { return sortableItem; });
/* concated harmony reexport TextIcon */__webpack_require__.d(__webpack_exports__, "TextIcon", function() { return TextIcon["default"]; });
/* concated harmony reexport withErrorHandling */__webpack_require__.d(__webpack_exports__, "withErrorHandling", function() { return withErrorHandling; });
/* concated harmony reexport WordCloud */__webpack_require__.d(__webpack_exports__, "WordCloud", function() { return WordCloud_WordCloud; });
/* concated harmony reexport FieldItem */__webpack_require__.d(__webpack_exports__, "FieldItem", function() { return FieldItem_FieldItem; });



















/***/ })
/******/ ]);
});